import { useSeoMeta } from '@unhead/react';
import { Brush } from 'lucide-react';
import { CraftProfileForm } from '@/components/CraftProfileForm';
import { SKATE_TATTOO_KIND, TATTOO_STYLE_LABELS, TATTOO_METHOD_LABELS } from '@/lib/types';

export default function BecomeTattooPage() {
  useSeoMeta({
    title: 'Become a Tattoo Artist - SkateSpots',
    description: 'List your tattoo work for the skate scene — styles, flash, custom and more.',
  });

  return (
    <CraftProfileForm
      config={{
        kind: SKATE_TATTOO_KIND,
        selfTag: 'skatetattoo',
        identifier: 'tattoo-profile',
        heading: 'Tattoo Artist',
        tagline: 'Ink for the scene — flash, custom, fine line & more',
        noun: 'tattoo artist',
        accentText: 'text-rose-400',
        accentBg: 'bg-rose-600',
        accentChip: 'bg-rose-600 text-white border-rose-600',
        accentChipHover: 'hover:border-rose-500/60 hover:text-rose-400',
        icon: Brush,
        rateLabel: 'Rate / Hourly',
        portfolioLabel: 'Portfolio link (IG, site)',
        skillSections: [
          { title: 'Styles', entries: Object.entries(TATTOO_STYLE_LABELS), required: true },
          { title: 'Method', entries: Object.entries(TATTOO_METHOD_LABELS) },
        ],
        extraFields: [
          { tag: 'studio', label: 'Studio / Shop', placeholder: 'Studio name (optional)' },
          { tag: 'books_open', label: 'Books Open', type: 'toggle', helper: 'Are you currently taking bookings?' },
        ],
      }}
    />
  );
}
